import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function CostOfInaction() {
  const sinSistema = ['Seguís sin entrenar', 'Te sentís cansada', 'No ves cambios', 'Empezás y dejás'];
  const conSistema = ['Tenés plan', 'Tenés estructura', 'Tenés resultados'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-60">
      <div className="text-center mb-16" data-id="element-61">
        <h2 className="font-display text-3xl md:text-5xl font-bold flex items-center justify-center gap-3 text-gray-900" data-id="element-62">
          <span data-id="element-63">⚖️</span> ¿CUÁNTO TE CUESTA NO HACERLO?
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-pink-50/50 border border-brand-danger/20 rounded-3xl p-8 relative overflow-hidden" data-id="element-65">
          <div className="absolute top-0 right-0 w-32 h-32 bg-red-50 rounded-bl-full" data-id="element-66" />
          <h3 className="text-2xl font-bold text-gray-500 mb-6" data-id="element-67">
            Sin sistema:
          </h3>
          <ul className="space-y-4" data-id="element-68">
            {sinSistema.map((item, i) => <li key={i} className="flex items-center gap-3 text-lg text-gray-500" data-id="element-69">
                <X size={20} className="text-brand-danger flex-shrink-0" data-id="element-70" />
                <span data-id="element-71">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-success/30 rounded-3xl p-8 relative overflow-hidden shadow-[0_0_30px_rgba(16,185,129,0.05)]" data-id="element-72">
          <div className="absolute top-0 right-0 w-32 h-32 bg-emerald-50 rounded-bl-full" data-id="element-73" />
          <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-74">
            Con sistema:
          </h3>
          <ul className="space-y-4" data-id="element-75">
            {conSistema.map((item, i) => <li key={i} className="flex items-center gap-3 text-xl text-gray-700 font-medium" data-id="element-76">
                <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0" data-id="element-77">
                  <Check size={14} className="text-brand-success" data-id="element-78" />
                </div>
                <span data-id="element-79">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}